export const aside = {
  groups: {
    general: 'Général',
    management: 'Gestion',
    planning: 'Planification',
    configuration: 'Configuration',
    account: 'Compte'
  },
  routes: {
    home: 'Accueil',
    dashboard: 'Tableau de bord',
    activities: 'Activités',
    users: 'Utilisateurs',
    profile: 'Profil',
    testStore: 'Test Store',
    products: 'Produits',
    categories: 'Catégories',
    customers: 'Clients',
    sales: 'Ventes',
    stockMovements: 'Mouvements de stock',
    cashMovements: 'Mouvements de caisse',
    settings: 'Paramètres',
    saleModels: 'Modèles de vente',
    tables: 'Tables',
    appointments: 'Rendez-vous',
    commandes: 'Commandes',
    activitySettings: 'Paramètres de l\'activité',
    pos: 'Point de Vente',
    payments: 'Paiements',
    usersManagement: 'Gestion Utilisateurs',
    approvisionnements: 'Approvisionnements',
    quickAccess: 'Accès Rapide'
  }
}; 